import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var FORMATS = {
  eot: 'embedded-opentype',
  otf: 'opentype',
  ttf: 'truetype'
};

var getExtMod = function getExtMod(ext, family) {
  if (ext === 'eot') {
    return '?#iefix';
  }

  if (ext === 'svg') {
    return "#".concat(family.replace(' ', ''));
  }

  return '';
};
/**
 *
 * @param {string} base
 * @param {Object} config
 * @param {Object} config.extensions
 * @param {Object} config.family
 * @param {Object} config.style
 * @param {Object} config.weight
 */


var fontFace = function fontFace(base, config) {
  var _context, _context6, _context7, _context8;

  var style = config.style || 'normal';
  var weight = config.weight || 'normal';

  var src = _mapInstanceProperty(_context = config.extensions).call(_context, function (ext) {
    var _context2, _context3, _context4, _context5;

    var extMod = getExtMod(ext, config.family);
    var format = FORMATS[ext] || ext;
    return _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "url('".concat(base)).call(_context5, config.file, ".")).call(_context4, ext)).call(_context3, extMod, "') format('")).call(_context2, format, "')");
  }).join(',\n    ');

  return _concatInstanceProperty(_context6 = _concatInstanceProperty(_context7 = _concatInstanceProperty(_context8 = "\n  @font-face {\n    font-family: '".concat(config.family, "';\n    font-style: ")).call(_context8, style, ";\n    font-weight: ")).call(_context7, weight, ";\n    src: ")).call(_context6, src, ";\n    font-display: swap;\n  }");
};

export default fontFace;